/**
 * SortDropdown — Sort control for token discovery grid.
 *
 * Options: Newest (default), Volume, Market Cap, Holders.
 * Values match TokenSortSchema: "newest", "volume", "market_cap", "holders".
 *
 * Story 3.4 — Task 4.3
 */

import { cn } from "../../lib/cn";

const SORT_OPTIONS = [
	{ value: "newest", label: "Newest" },
	{ value: "volume", label: "Volume" },
	{ value: "market_cap", label: "Market Cap" },
	{ value: "holders", label: "Holders" },
] as const;

type SortDropdownProps = {
	value: string;
	onChange: (sort: string) => void;
};

export function SortDropdown({ value, onChange }: SortDropdownProps) {
	return (
		<div className="flex items-center gap-2">
			<label
				htmlFor="sort-select"
				className="text-xs font-medium text-pastel-gray whitespace-nowrap"
			>
				Sort by
			</label>
			<select
				id="sort-select"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className={cn(
					"rounded-lg border border-pastel-border bg-white px-3 py-2 text-sm text-pastel-black",
					"focus:outline-none focus:ring-2 focus:ring-pastel-vibrant-blue/40 focus:border-pastel-vibrant-blue",
					"transition-colors"
				)}
			>
				{SORT_OPTIONS.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
}
